var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnameimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#006779"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 22.375C22.3676 22.375 23.375 21.3676 23.375 20.125C23.375 18.8824 22.3676 17.875 21.125 17.875C19.8824 17.875 18.875 18.8824 18.875 20.125C18.875 21.3676 19.8824 22.375 21.125 22.375Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 26.875C25.625 28.1177 25.625 29.125 21.125 29.125C16.625 29.125 16.625 28.1177 16.625 26.875C16.625 25.6323 18.6397 24.625 21.125 24.625C23.6102 24.625 25.625 25.6323 25.625 26.875Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 23.5C13.25 19.2574 13.25 17.136 14.568 15.818C15.886 14.5 18.0074 14.5 22.25 14.5H26.75C30.9926 14.5 33.114 14.5 34.4319 15.818C35.75 17.136 35.75 19.2574 35.75 23.5C35.75 27.7426 35.75 29.864 34.4319 31.1819C33.114 32.5 30.9926 32.5 26.75 32.5H22.25C18.0074 32.5 15.886 32.5 14.568 31.1819C13.25 29.864 13.25 27.7426 13.25 23.5Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 23.5H27.875",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 20.125H26.75",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 26.875H29",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnameimage);
export default __webpack_public_path__ + "static/media/cnameimage.5fe096e341bbfd6314851c5543b5b117.svg";
export { ForwardRef as ReactComponent };